__turbopack_context__.v({
  "avatar": "kjdYNW_avatar",
  "avatarContainer": "kjdYNW_avatarContainer",
  "left": "kjdYNW_left",
  "name": "kjdYNW_name",
  "nameRole": "kjdYNW_nameRole",
  "right": "kjdYNW_right",
  "role": "kjdYNW_role",
  "root": "kjdYNW_root",
  "text": "kjdYNW_text",
  "tlIcon": "kjdYNW_tlIcon",
});
